import script from "./SecondaryDeviceBlockedOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryDeviceBlockedOverlay.vue?vue&type=script&setup=true&lang=js"

import "./SecondaryDeviceBlockedOverlay.vue?vue&type=style&index=0&id=538d0a2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538d0a2f"]])

export default __exports__